import type { TextareaFieldConfig } from '@shared/types/interactiveFields';

type Language = 'bg' | 'de' | 'en';

interface TextareaFieldProps {
  field: TextareaFieldConfig;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
  language: Language;
}

export function TextareaField({ field, value, onChange, error, disabled, language }: TextareaFieldProps) {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        {field.label[language] || field.label.bg}
        {field.required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <textarea
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={field.placeholder}
        rows={field.rows || 3}
        maxLength={field.maxLength}
        disabled={disabled}
        className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none ${
          error ? 'border-red-500' : 'border-gray-300'
        }`}
      />
      {field.helpText && (
        <p className="text-sm text-gray-500">
          {field.helpText[language] || field.helpText.bg}
        </p>
      )}
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
}
